;(function () {

var SliderView = require('../views/slider');
// var ItemTemplate = require('../views/templates/item.html');
var ProductLiTemplate = require('../views/templates/product-li.html');
var PaginationTemplate = require('../views/templates/pagination.html');

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function prepareProductData(hits) {
  var products = [];

  hits.forEach(function (hit) {
    var image = hit.product_image;
    var extension = image.split('.').pop();
    extension = '.' + extension.split('?')[0];

    hit.medium_image = image.split(extension)[0] + '_x311' + extension;
    hit.large_image = image.split(extension)[0] + '_x700' + extension;
    hit.display_price = '$' + hit.variants_min_price;
    hit.price = hit.variants_min_price;
    hit.url = '/products/'+hit.handle;

    /* Assume all variant options are identical for product */
    hit.variants.forEach(function (variant) {
      hit.inventory_policy = variant.inventory_policy;
      hit.inventory_management = variant.inventory_management;
      if (variant.compare_at_price) {
        hit.compare_at_price = parseFloat(variant.compare_at_price);
      }
    });

    var now = new Date().valueOf();
    var diffDays = (now - hit.published_date) / 1000 / 3600 / 24;

    if (diffDays < 10) {
      hit.badge = 'new';
    }

    if (hit.compare_at_price > hit.price) {
      hit.badge = 'sale';
    }

    if (hit.tags.indexOf('exclusive') !== -1) {
      hit.badge = 'exclusive';
    }

    if (hit.tags.indexOf('best-seller') !== -1) {
      hit.badge = 'best-seller';
    }

    products.push(hit);
  });

  // console.log(hits);
  return products;
}

function prepareData(variants) {
  // console.log(variants);
  var products = [];

  variants.forEach(function (variant) {
    var image = variant.image;
    var extension = image.split('.').pop();
    extension = '.' + extension.split('?')[0];

    variant.medium_image = image.split(extension)[0] + '_x311' + extension;
    variant.large_image = image.split(extension)[0] + '_x700' + extension;
    variant.display_price = '$' + variant.price;
    variant.url = '/products/'+variant.handle+'?variant='+variant.objectID;

    products.push(variant);
  });

  return products;
}

function updateUrlParameters(query, page) {
  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q='+query+'&page='+page;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

// var debug = window.Cookies.get('rr_debug');

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('init search page');

    this.client = algoliasearch('808GQH9HV4', '18d27a98c6c38e9629a162b57cd5de4a');
    // if (debug) {
      this.index = this.client.initIndex('products');
    // } else {
    //   this.index = this.client.initIndex('shopify_products');
    // }

    this.query = getParameterByName('q');
    this.page = parseInt(getParameterByName('page')) - 1 || 0;

    this.$noResults = this.$el.find('#no-results-found')
    this.$resultsContainer = this.$el.find("#new-search .results");
    this.$title = this.$el.find('h1.text-center');
    this.$input = this.$el.find('.main-content input[name="q"]');

    this.performSearch();

    var self = this;
    $(window).on("popstate", function(e) {
      self.query = getParameterByName('q');
      self.page = parseInt(getParameterByName('page')) - 1 || 0;
      self.$input.val(self.query);
      self.performSearch();
    });

    this.updateUrlParameters = _.debounce(function () {
      updateUrlParameters(self.query, self.page);
    }, 2000, false);

    this.ajaxSearch = _.debounce(function(e) {
      var val = $(e.currentTarget).val() || '';
      // val = val.toUpperCase();

      if (val !== self.query) {
        self.paramReset = true;
        self.page = 0;
        self.query = val;
        self.performSearch();
      }
    }, 250, false);

    $('.slider.desktop').each(function () {
      new SliderView({ el: this, group: 3 });
    });

    $('.slider.mobile').each(function () {
      new SliderView({ el: this });
    })

    this.guid = window.App.guid();
    /* Resize Logic */
    $(window).on('resize.'+this.guid, _.debounce(_.bind(this.resize, this)));
    /* Let fonts load, then resize */
    $(window).on('load', function () { $(window).trigger('resize'); });

    this.resize();
  },

  performSearch: function() {
    var self = this;

    // if (debug) {
      this.index.search({
        query: this.query,
        hitsPerPage: 30,
        page: this.page,
        filters: 'published:true'
      }, function searchDone(err, content) {
          if (err) { return console.log(err); };

          $(window).scrollTop(0);

          if (content.hits.length > 0) {
            self.renderResults(content);
          } else {
            self.renderNoResults();
          }
      });
    // } else {
      // this.index.search({
      //   query: this.query,
      //   hitsPerPage: 30,
      //   page: this.page
      // }, function searchDone(err, content) {
      //     if (err) { return console.log(err); };

      //     $(window).scrollTop(0);

      //     if (content.hits.length > 0) {
      //       self.renderResults(content);
      //     } else {
      //       self.renderNoResults();
      //     }
      // });
    // }
  },

  renderResults: function (content) {
    this.$noResults.hide();

    this.$resultsContainer.find('.pagination').remove();
    this.$resultsContainer.find('.products').empty();
    this.$resultsContainer.show();

    var title = "Here's what we found for \""+this.query+"\"";
    if (!this.query) {
      title = "Showing all products..."
    }
    this.$title.text(title);

    // if (debug) {
      var data = prepareProductData(content.hits);
    // } else {
      // var data = prepareData(content.hits);
    // }
    var $content = this.$el.find('.products');

    data.forEach(function(product) {
      // if (debug) {
        $content.append( $( _.template(ProductLiTemplate)({ product: product }) ) );
      // } else {
        // $content.append( $( _.template(ItemTemplate)({ product: product }) ) );
      // }
    });
    
    setTimeout(window.fetchHiResCollectionImages, 0);

    this.renderPagination(content);

    var self = this;
    setTimeout(function () {
      self.resize();
    }, 100);
  },

  renderPagination: function (content) {
    this.$resultsContainer.append( $( _.template(PaginationTemplate)({ page: this.page, pages: content.nbPages }) ) );    
  },

  renderNoResults: function () {
    // console.log('rendering no results');
    this.$resultsContainer.hide();
    this.$noResults.show();

    var title = "Sorry, We couldn't find anything under \""+this.query+"\".";
    this.$title.text(title);
  },

  keyup: function(e) {
    this.ajaxSearch(e);
    // this.updateUrlParameters();

    // e.preventDefault();
    // e.stopPropagation();
  },

  resize: function () {
    /* Even for mobile */
    var $products = this.$resultsContainer.find('.products').children();
    for (var i = 0; i < $products.length; i+=2) {
      var $left = $($products[i]).find('.content').css('height', '');
      var $right = $($products[i+1]).find('.content').css('height', '');

      var max = _.max([$left.outerHeight(true), $right.outerHeight(true)]);

      $left.css('height', max);
      $right.css('height', max);
    }

  },

  events: {
    'click #new-search .pagination > span': function (e) {
      var $this = $(e.currentTarget);
      var idx = $this.data('idx');
      if (idx !== undefined && !$this.hasClass('disabled') && idx !== this.page) {

        if (this.paramReset) {
          updateUrlParameters(this.query, 1);
          this.paramReset = false;
        }

        this.page = parseInt(idx);
        this.performSearch();
        updateUrlParameters(this.query, idx+1);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    'submit .main-content form.search-bar': function (e) {
      if (!window.App.touch) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    'click .products > li a': function (e) {
      if (this.paramReset) {
        updateUrlParameters(this.query, 1);
        this.paramReset = false;
      }
    },
    'keyup .main-content input[name="q"]': 'keyup'
  }
});

module.exports = PageView;

}());